import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type {
  IPantallaCodigoVinculacion,
  IPantallaDispositivo,
  IPantallaDispositivosResumen,
  IPantallaRevocarRequest,
  IPantallaRevocarResponse,
  IPantallaSetVolumenRequest,
  IPantallaSetVolumenResponse,
  IPantallaVigenciaRequest,
  IPantallaVigenciaResponse
} from '@/modules/Pantalla/interfaces/IPantallaDispositivo'

export class PantallaDispositivoService extends BaseService<IPantallaDispositivo> {
  constructor() {
    super({ baseUrl: 'pantalla/dispositivos/' })
  }

  async generarCodigo(): Promise<
    AxiosResponse<IResponseApi<IPantallaCodigoVinculacion>>
  > {
    return this.http
      .post<IResponseApi<IPantallaCodigoVinculacion>>('/generar-codigo', {})
      .catch(this.errorHandle)
  }

  async listarDispositivos(): Promise<
    AxiosResponse<IResponseApi<IPantallaDispositivosResumen>>
  > {
    return this.http
      .get<IResponseApi<IPantallaDispositivosResumen>>('/list')
      .catch(this.errorHandle)
  }

  async revocar(
    data: IPantallaRevocarRequest
  ): Promise<AxiosResponse<IResponseApi<IPantallaRevocarResponse>>> {
    return this.http
      .post<IResponseApi<IPantallaRevocarResponse>>('/revocar', data)
      .catch(this.errorHandle)
  }

  async setVolumen(
    data: IPantallaSetVolumenRequest
  ): Promise<AxiosResponse<IResponseApi<IPantallaSetVolumenResponse>>> {
    return this.http
      .post<IResponseApi<IPantallaSetVolumenResponse>>('/set-volumen', data)
      .catch(this.errorHandle)
  }

  async actualizarVigencia(
    data: IPantallaVigenciaRequest
  ): Promise<AxiosResponse<IResponseApi<IPantallaVigenciaResponse>>> {
    return this.http
      .put<IResponseApi<IPantallaVigenciaResponse>>('/vigencia', data)
      .catch(this.errorHandle)
  }
}
